<script>
	const model = require('model/model');
	const Store = require('kvstore');

	module.exports = {
		props: [
			'article',
			'assessment',
			'question-sets',
			'ordered-students',
			'route-context',
			'book-of-knowledge',
			'assignmentDeadline',
			'printView',
			'exportData',
			'roster'
		],
		modelData: ['resultsTab', 'resultsSubTab', 'student', 'qset'],
		components: {
			classresults: require('./class-results.vue').default,
			studentresults: require('./student-results.vue').default,
			questions: require('./questions.vue').default,
			vocabresults: require('./vocab-results.vue').default,
			'tab-container': require('components/tab-container.vue').default
		},
		mounted() {
			// if we return to this tab from a different tab, always start off on classresults
			if (!this.resultsTab) {
				model.set('resultsTab', 'classresults');
			}
			if (this.resultsTab === 'classresults' && this.resultsSubTab !== 'vocabresults') {
				this.student = '';
			}

			this.unwatch = model.change('resultsSubTab', resultsSubTab => {
				if (resultsSubTab && resultsSubTab.charAt(0) === 'q') {
					model.set('qset', resultsSubTab.substr(1));
				} else {
					model.set('qset', '');
				}
			});
		},
		beforeDestroy() {
			if (this.unwatch) {
				this.unwatch();
				this.unwatch = null;
			}
		},
		computed: {
			vocabularyAssigned() {
				return this.assessment && this.assessment.options.va && this.assessment.options.va.length > 0;
			},
			currentQuestionSet: function () {
				let questionSets = this.questionSets;
				if (!this.resultsSubTab || this.resultsSubTab.charAt(0) !== 'q') {
					return [];
				}
				let qsetId = parseInt(this.resultsSubTab.substr(1));
				let set = [];

				if (questionSets && questionSets.length && qsetId) {
					questionSets.every(qs => {
						if (qs.id === qsetId) {
							set.push(qs);
							return false;
						}
						return true;
					});
				}

				return set;
			},
			resultsTabComponent() {
				if (this.resultsSubTab === 'vocabresults') {
					return 'vocabresults';
				}
				return this.resultsTab;
			},

			canRefresh() {
				const { studentsSubmitted, studentCount, closed, suidsSubmitted } = this.assessment;

				if (this.resultsTab === 'studentresults') {
					return suidsSubmitted ? !suidsSubmitted[this.student] : false;
				}

				const allSubmitted = studentsSubmitted === studentCount;

				return !allSubmitted && !closed;
			},
			isAAD() {
				return this.article.productType === 'AAD';
			}
		},
		methods: {
			refreshView() {
				Store.call('$broadcast', 'assessment-needs-reload', false);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.assessment {
		.grid-toolbar-container {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
		}

		.nav-toggle {
			display: inline-block;
			nav {
				padding: 0;
			}
		}

		.assessment-results-sub-tabs {
			display: inline-flex;
		}
	}
</style>
<template>
	<div class="results-container">
		<template v-if="orderedStudents.length === 0">
			<div class="wrapper">
				<p>There are no students in this class.</p>
				<a
					:href="`/class-admin#!classAdmin:invite/classCode:${assessment.classCode}`"
					class="button"
					>Invite Students to Join Class</a
				>
			</div>
		</template>
		<template v-if="orderedStudents.length > 0">
			<!-- questionSets.length=={{ questionSets.length }}&nbsp;&nbsp;&nbsp;
			resultsTab=={{ resultsTab }}&nbsp;&nbsp;&nbsp;
			resultsTabComponent=={{ resultsTabComponent }}&nbsp;&nbsp;&nbsp;
			vocabularyAssigned=={{ vocabularyAssigned }}&nbsp;&nbsp;&nbsp; -->
			<div
				class="wrapper nav-wrapper"
				v-show="questionSets.length || vocabularyAssigned || isAAD">
				<tab-container
					v-if="(questionSets.length || vocabularyAssigned) && !isAAD"
					class="print-hidden"
					variant="pill-tabs"
					model-key="resultsSubTab">
					<button
						v-for="qset in questionSets"
						:data-tab="`q${qset.id}`"
						:key="qset.id"
						:data-qset="qset.id">
						{{ qset.title }}
					</button>
					<button
						v-if="vocabularyAssigned"
						data-tab="vocabresults">
						Vocabulary Activity
					</button>
				</tab-container>

				<div class="grid-toolbar-container margin-bottom-medium">
					<div
						v-show="!isAAD && resultsTab !== 'studentresults' && resultsSubTab !== 'vocabresults'"
						class="nav-toggle print-hidden">
						View By&nbsp;
						<tab-container
							class="assessment-results-sub-tabs assessment-results-view"
							model-key="resultsTab"
							variant="toggle"
							default-tab="classresults">
							<button
								class="button -small"
								data-tab="classresults">
								Student
							</button>
							<button
								class="button -small"
								data-tab="questions">
								Question
							</button>
						</tab-container>
					</div>
					<div
						v-show="['classresults', 'studentresults', 'questions'].includes(resultsTab) || isAAD"
						:class="`grid-tools print-hidden${isAAD ? ' margin-top-medium' : ''}`">
						<button
							class="button -small blue-outline refresh-results"
							v-if="canRefresh"
							@click="refreshView"
							aria-label="Refresh results">
							<i
								class="fa-solid fa-rotate fa-lg"
								aria-hidden="true"></i>
						</button>
						<button
							class="button -small blue-outline print-results"
							v-if="resultsTab !== 'questions'"
							@click="printView"
							aria-label="Print">
							<i
								class="fa-solid fa-print fa-lg"
								aria-hidden="true"></i>
						</button>
						<button
							class="button -small blue-outline export-results"
							v-if="resultsTab === 'classresults'"
							@click="exportData"
							aria-label="Export results">
							<i
								class="fa-solid fa-up-right-from-square fa-lg"
								aria-hidden="true"></i>
						</button>
					</div>
				</div>
			</div>
			<keep-alive>
				<component
					:is="resultsTabComponent"
					:route-context="routeContext"
					:article="article"
					:ordered-students="orderedStudents"
					:question-sets="currentQuestionSet"
					:assessment="assessment"
					:assignment-id="routeContext.params.assignmentId"
					:stepreads="stepReads"
					:assignment-deadline="assignmentDeadline"
					:roster="roster"
					ref="resultsSubTabPanel"
					:data-panel="resultsSubTab"></component>
			</keep-alive>
		</template>
	</div>
</template>
